import React from 'react';
import Image from '@elements/image';
import { ServiceItemProps } from './service-item.props';
import LabsItemSchema from '@schema/labs/labs-item';
import { Button, Div, Media, Text } from '@pezeshk-book/ui-kit';

const ServiceItem = ({ title, imageUrl, onClick, buttonTitle }: ServiceItemProps) => {
  return (
    <Div onClick={onClick} className={'basis-full md:basis-[48.5%] md:h-[86px] grow gap-x-3 cursor-pointer'} itemScope itemType="https://schema.org/Service">
      <Div className={'w-14 h-14 md:w-[86px] sm:h-full bg-primary justify-center items-center rounded-lg md:rounded-2xl'}>
        <Div className={'relative w-10 h-10 sm:w-16 sm:h-16'} itemProp="image">
          <Image sizes={'10vw'} className={'object-contain'} src={imageUrl} alt={title} fill={false} width={72} height={72}/>
        </Div>
      </Div>
      <Div className={'h-14 sm:h-full bg-control-50 justify-between items-center rounded-lg md:rounded-2xl px-4 grow shadow-xl'}>
        <Text className={'md:max-w-[45%]'} itemProp={'name'} align={'start'} type={'bold'} color={'grey.800'}>{title}</Text>
        <Media greaterThan={'xs'}>
          <Button variant={'outlined'} onClick={onClick} className={'w-[112px]'} shape={'rectangle'} rounded={'medium'}>
            {buttonTitle}
          </Button>
        </Media>
      </Div>
      <LabsItemSchema image={imageUrl}/>
    </Div>
  );
};

export default ServiceItem;
